export default __webpack_public_path__ + "static/media/sec5.902fb1e1.svg";